// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FsCv4sBDokU6AN {
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 100%;
}
`, ""]);
// Exports
export var logo = `FsCv4sBDokU6AN`;
export default ___CSS_LOADER_EXPORT___;
